import { computed, readonly, ref } from 'vue';
import { defineStore } from 'pinia';

import { CustomerFlow } from '../models';

export const useCustomerFlowStore = defineStore('CustomerFlow', () => {
  // State
  const customerFlow = ref<CustomerFlow>(CustomerFlow.Base);

  // Getters
  const isFlightOnlyFromMarketplaceFlow = computed<boolean>(
    () => customerFlow.value === CustomerFlow.FlightOnlyFromMarketplace
  );

  // Actions
  function setCustomerFlow(flow: CustomerFlow): void {
    customerFlow.value = flow;
  }

  return {
    // State
    customerFlow: readonly(customerFlow),

    // Getters
    isFlightOnlyFromMarketplaceFlow,

    // Actions
    setCustomerFlow,
  };
});
